import { render } from "./mentalHealthPolicy.vue?vue&type=template&id=1606865d&scoped=true"
import script from "./mentalHealthPolicy.vue?vue&type=script&lang=js"
export * from "./mentalHealthPolicy.vue?vue&type=script&lang=js"

import "./mentalHealthPolicy.vue?vue&type=style&index=0&id=1606865d&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1606865d"]])

export default __exports__